import { Route } from "vue-router"

export default [
  {
    path: "",
    component: () => import("@/views/tutorials/Index.vue"),
  },
  {
    path: ":id",
    component: () => import("@/views/tutorials/Detail.vue"),
    props: route => ({
      tutorialId: route.params.id,
    }),
  },
]
